import { useHandleSignInCallback } from '@logto/react';
import { useNavigate } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import { getConfig } from '@/config';
import { takeStaffSignInReturn } from '@/providers/staffSignIn';

const centred = 'd-flex justify-content-center align-items-center';

/** Where Logto returns after sign-in; the SDK reads the code here and the visitor goes back to the page that asked. */
const ProviderCallback = () => {
  const navigate = useNavigate();
  const { error } = useHandleSignInCallback(() => {
    navigate(takeStaffSignInReturn() ?? '/', { replace: true });
  });

  if (error) {
    return (
      <div className={centred} style={{ minHeight: '60vh' }}>
        <Alert variant="danger" className="py-2">
          Sign-in could not be completed: {error.message}
        </Alert>
      </div>
    );
  }

  return (
    <div className={`${centred} gap-2`} style={{ minHeight: '60vh' }}>
      <Spinner animation="border" size="sm" />
      <span>Finishing sign-in…</span>
    </div>
  );
};

/**
 * A stage with no Logto application mounts no provider, and the SDK's hooks throw outside one — so
 * this route has to answer before reaching them.
 */
const CallbackPage = () => {
  if (!getConfig().logtoAppId) {
    return (
      <div className={centred} style={{ minHeight: '60vh' }}>
        <Alert variant="warning" className="py-2">
          Staff sign-in is not available on this environment yet.
        </Alert>
      </div>
    );
  }

  return <ProviderCallback />;
};

export default CallbackPage;
